module.exports = __webpack_public_path__ + "static/media/about_3.7564e935.svg";